/**
 * Registers the PWA service worker and drives the opt-in banner's subscribe
 * flow. Plain deferred script (matches the auto-close-details.js convention
 * in snippets/scripts.liquid) — no bundler, no ES module, no dependencies.
 */
(function () {
  var API_BASE = 'https://app.elirian.com';
  var DISMISS_KEY = 'elirian_push_prompt_dismissed';

  function urlBase64ToUint8Array(base64String) {
    var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    var base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for (var i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  function swUrl() {
    var el = document.currentScript;
    return (el && el.dataset && el.dataset.swUrl) || '/sw.js';
  }

  function registerServiceWorker() {
    if (!('serviceWorker' in navigator)) return Promise.resolve(null);
    return navigator.serviceWorker.register(swUrl(), { scope: '/' }).catch(function () {
      return null;
    });
  }

  function subscribeToPush() {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      return Promise.reject(new Error('Push not supported'));
    }

    return navigator.serviceWorker.ready
      .then(function (registration) {
        return fetch(API_BASE + '/api/v1/push/vapid-key')
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            return registration.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: urlBase64ToUint8Array(data.publicKey),
            });
          });
      })
      .then(function (subscription) {
        var config = window.ELIRIAN_CONFIG || {};
        return fetch(API_BASE + '/api/v1/push/subscribe', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            endpoint: subscription.endpoint,
            keys: {
              p256dh: arrayBufferToBase64(subscription.getKey('p256dh')),
              auth: arrayBufferToBase64(subscription.getKey('auth')),
            },
            email: config.customerEmail || null,
            shopify_customer_id: config.customerId ? String(config.customerId) : null,
          }),
        });
      });
  }

  function arrayBufferToBase64(buffer) {
    var bytes = new Uint8Array(buffer);
    var binary = '';
    for (var i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window
      .btoa(binary)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  }

  function shouldShowBanner() {
    if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) {
      return Promise.resolve(false);
    }
    if (Notification.permission === 'denied') return Promise.resolve(false);
    if (localStorage.getItem(DISMISS_KEY)) return Promise.resolve(false);
    if (Notification.permission === 'granted') return Promise.resolve(false);

    return Promise.resolve(true);
  }

  function initBanner() {
    var banner = document.querySelector('[data-pwa-opt-in]');
    if (!banner) return;

    shouldShowBanner().then(function (show) {
      if (!show) return;
      banner.hidden = false;
    });

    var enableBtn = banner.querySelector('[data-pwa-enable]');
    var dismissBtn = banner.querySelector('[data-pwa-dismiss]');

    if (enableBtn) {
      enableBtn.addEventListener('click', function () {
        Notification.requestPermission().then(function (permission) {
          banner.hidden = true;
          if (permission === 'granted') {
            subscribeToPush().catch(function () {
              // Silent failure — the banner has already been dismissed;
              // the customer can still browse normally.
            });
          } else {
            localStorage.setItem(DISMISS_KEY, '1');
          }
        });
      });
    }

    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        localStorage.setItem(DISMISS_KEY, '1');
        banner.hidden = true;
      });
    }
  }

  registerServiceWorker();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBanner);
  } else {
    initBanner();
  }
})();
